import React from "react"
import Sticky from "react-stickynode"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import ResetCSS from "@/common/assets/css/style"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import SectionHeading from "@/common/components/SectionHeading"
import SectionLine from "@/common/components/SectionLine"
import MetaData from "@/common/components/MetaData"
import Container from "@/common/components/UI/Container"
import { AppWrapper, ContentWrapper } from "@/containers/common/style"

const Legal = () => {
  const { t } = useTranslation("privacy")

  return (
    <div>
      <>
        <MetaData
          title={t("meta.title-2")}
          description={t("meta.description")}
          url={t("meta.url")}
          image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        />

        <ResetCSS />
        {/* end of global and reset style */}

        {/* start app classic landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={1000} activeClass="sticky-active">
            <NavbarNew />
          </Sticky>
          <Container>
            <TitleWrapper>
              <SectionHeading a title={t("title-2")} slogan="" />
            </TitleWrapper>
            <ContentWrapper>
              <Wrapper>
                <p>{t("policy.p1")}</p>
                <p>{t("policy.p2")}</p>
                <p>{t("policy.p3")}</p>
                <h3>{t("policy.scope.title")}</h3>
                <p>{t("policy.scope.p1")}</p>
                <p>{t("policy.scope.p2")}</p>
                <p>{t("policy.scope.p3")}</p>
                <p>{t("policy.scope.p4")}</p>

                <h3>{t("policy.method.title")}</h3>
                <p>{t("policy.method.p1")}</p>
                <br />
                <ol>
                  <li>{t("policy.method.list.1")}</li>
                  <li>{t("policy.method.list.2")}</li>
                  <li>{t("policy.method.list.3")}</li>
                  <li>{t("policy.method.list.4")}</li>
                  <li>{t("policy.method.list.5")}</li>
                  <li>{t("policy.method.list.6")}</li>
                </ol>
                <h3>{t("policy.purpose.title")}</h3>
                <p>{t("policy.purpose.p1")}</p>
                <br />
                <ol>
                  <li>{t("policy.purpose.list.1")}</li>
                  <li>{t("policy.purpose.list.2")}</li>
                  <li>{t("policy.purpose.list.3")}</li>
                  <li>{t("policy.purpose.list.4")}</li>
                  <li>{t("policy.purpose.list.5")}</li>
                  <li>{t("policy.purpose.list.6")}</li>
                  <li>{t("policy.purpose.list.7")}</li>
                  <li>{t("policy.purpose.list.8")}</li>
                  <li>{t("policy.purpose.list.9")}</li>
                  <li>{t("policy.purpose.list.10")}</li>
                  <li>{t("policy.purpose.list.11")}</li>
                  <li>{t("policy.purpose.list.12")}</li>
                  <li>{t("policy.purpose.list.13")}</li>
                  <li>{t("policy.purpose.list.14")}</li>
                  <li>{t("policy.purpose.list.15")}</li>
                  <li>{t("policy.purpose.list.16")}</li>
                  <li>{t("policy.purpose.list.17")}</li>
                </ol>

                <h3>{t("policy.types.title")}</h3>
                <p>{t("policy.types.p1")}</p>
                <br />
                <ol>
                  <li>{t("policy.types.list.1")}</li>
                  <li>{t("policy.types.list.2")}</li>
                  <li>{t("policy.types.list.3")}</li>
                  <li>{t("policy.types.list.4")}</li>
                  <li>{t("policy.types.list.5")}</li>
                  <li>{t("policy.types.list.6")}</li>
                  <li>{t("policy.types.list.8")}</li>
                  <li>{t("policy.types.list.9")}</li>
                </ol>
                <p>{t("policy.types.p2")}</p>

                <h3>{t("policy.use.title")}</h3>
                <p>{t("policy.use.p1")}</p>
                <br />
                <ol>
                  <li>{t("policy.use.list.1")}</li>
                  <li>{t("policy.use.list.3")}</li>
                  <li>{t("policy.use.list.4")}</li>
                  <li>{t("policy.use.list.5")}</li>
                  <li>{t("policy.use.list.6")}</li>
                </ol>

                <h3>{t("policy.personal.title")}</h3>
                <h4>{t("policy.personal.section1.title")}</h4>
                <p>{t("policy.personal.section1.p")}</p>
                <h4>{t("policy.personal.section2.title")}</h4>
                <p>{t("policy.personal.section2.p")}</p>
                <h4>{t("policy.personal.section3.title")}</h4>
                <ol>
                  <li>{t("policy.personal.section3.list.1")}</li>
                  <li>{t("policy.personal.section3.list.2")}</li>
                  <li>{t("policy.personal.section3.list.3")}</li>
                  <li>{t("policy.personal.section3.list.4")}</li>
                  <li>{t("policy.personal.section3.list.5")}</li>
                  <li>{t("policy.personal.section3.list.6")}</li>
                  <li>{t("policy.personal.section3.list.7")}</li>
                  <li>{t("policy.personal.section3.list.8")}</li>
                  <li>{t("policy.personal.section3.list.9")}</li>
                </ol>

                <h3>{t("policy.data.title")}</h3>
                <p>{t("policy.data.p")}</p>

                <h3>{t("policy.rights.title")}</h3>
                <p>{t("policy.rights.p1")}</p>
                <br />
                <ol>
                  <li>{t("policy.rights.list.1")}</li>
                  <li>{t("policy.rights.list.2")}</li>
                  <li>{t("policy.rights.list.3")}</li>
                </ol>
                <p>{t("policy.rights.p2")}</p>

                <h3>{t("policy.cookie.title")}</h3>
                <p>{t("policy.cookie.p")}</p>

                <h3>{t("policy.influence.title")}</h3>
                <p>{t("policy.influence.p")}</p>

                <h3>{t("policy.self.title")}</h3>
                <p>{t("policy.self.p")}</p>

                <h3>{t("policy.amend.title")}</h3>
                <p>{t("policy.amend.p")}</p>

                <h3>{t("policy.governing.title")}</h3>
                <p>{t("policy.governing.p")}</p>

                <br />
                <br />
                <p>{t("policy.footer")}</p>
              </Wrapper>
            </ContentWrapper>

            <SectionLine />
          </Container>
          <Footer />
        </AppWrapper>
      </>
    </div>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "privacy",
      "common",
      "contactUs"
    ]))
  }
})

export default Legal

const TitleWrapper = styled.div`
  padding-top: 160px;
  @media (max-width: 768px) {
    padding-top: 100px;
  }
`

const Wrapper = styled.div`
  max-width: 1024px;
  margin-bottom: 200px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 768px) {
    margin-bottom: 80px;
  }
  h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-top: 2.5rem;
    margin-bottom: 2rem;
    color: ${themeGet("colors.primary")};
  }
  h3 {
    // font-size: 1.75rem;
    margin-top: 2rem;
    margin-bottom: 1.75rem;
  }
  h4 {
    // font-size: 1.25rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 10px;
  }
  ul {
    margin-bottom: 4px;
    list-style-type: square;
    li {
      margin-left: 20px;
      margin-bottom: 20px;
    }
  }

  ol {
    list-style-type: decimal;
    li {
      margin-left: 20px;
      list-style-type: decimal;
      margin-bottom: 20px;
      div {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
  @media (max-width: 768px) {
    ul,
    ol {
      li {
        margin-left: 0px;
      }
    }
  }
`
